import {
  getCurrentMerchant,
  getCurrentSite,
  getAccessToken
} from 'redux/modules/currentUser/selectors'
import {getMerchantBySite} from 'redux/modules/sites/selectors'
import formatQuery from 'utils/formatQuery'
import _ from 'lodash'

const availableIntegrations = [
  // {
  //   channelId: 'bing',
  //   channelGroupId: 'sem',
  //   serviceId: 'bing',
  //   icon: 'integration-api',
  //   title: 'Bing',
  //   multiple: true,
  //   api: true
  // },
  // {
  //   channelId: 'google',
  //   channelGroupId: 'sem',
  //   serviceId: 'google',
  //   icon: 'integration-api',
  //   title: 'Google Adwords',
  //   multiple: true,
  //   api: true
  // },
  // {
  //   channelId: 'facebook',
  //   channelGroupId: 'social_ppc',
  //   serviceId: 'facebook',
  //   icon: 'integration-api',
  //   title: 'Facebook',
  //   multiple: true,
  //   api: true
  // },
  {
    serviceId: 'manual-input',
    icon: 'integration-manual-input',
    title: 'Manual Input',
    all: true,
    multiple: true
  },
  // {
  //   serviceId: 'google-spreadsheet',
  //   icon: 'integration-spreadsheet',
  //   title: 'Google Spreadsheet',
  //   all: true,
  //   multiple: true
  // },
  {
    serviceId: 'criteo',
    channelId: 'criteo',
    channelGroupId: 'retargeting',
    icon: 'channel-criteo',
    title: 'Criteo',
    multiple: true,
    api: true
  }
]

export const integrationTypes = {
  'fixed-cost': 'Fixed Cost',
  'cost-per-visit': 'Cost per Visit',
  'cost-per-order': 'Cost per Conversion',
  'revenue-share': 'Revenue Share',
  'marketing-share': 'Marketing Share'
}

const availableIntegrationsByService = _.groupBy(availableIntegrations.map(int => {
  return {...int, channel: {channelGroupId: int.channelGroupId, channelId: int.channelId}}
}), 'serviceId')

function getAllIntegrations(integrations) {
  return integrations.map(item => {
    const info = availableIntegrationsByService[item.serviceId][0]
    const {icon, title} = info

    if (item.costConfig && item.costConfig.channel) return {...item, icon, title}

    return {...item, icon, title, costConfig: {...info, ...(item.costConfig || {})}}
  })
}

export function getAuthorizationURLParams(state, callbackURL) {
  const {id: merchantSiteId} = getCurrentSite(state) || {}

  if (!merchantSiteId) return null

  const merchant = getMerchantBySite(state, merchantSiteId)
  const accessToken = getAccessToken(state)

  if (!accessToken) return null

  const params = formatQuery({
    access_token: accessToken,
    merchantSiteId,
    callbackURL: `${callbackURL}`
  })

  return {
    prefix: `${__API_URL__}merchants/${merchant.id}/integrations/`,
    postfix: `/connect?${params}`
  }
}

export function getIntegrationCosts(state, integrationId) {
  const {integrationCosts} = state.integrations

  if (!integrationCosts) return null

  return integrationCosts[integrationId] ? integrationCosts[integrationId].concat().reverse() : null
}

export function getAllConnectedIntegrations(state) {
  const {integrations} = state.integrations

  if (!integrations || !integrations.length) return null

  return integrations
    .map(i => {
      const {
        icon,
        title,
        api,
        channelGroupId,
        channelId
      } = availableIntegrations.find(t => t.serviceId === i.serviceId)
      const channel = _.get(i, 'costConfig.channel')
      if (!channel) {
        _.set(i, 'costConfig.channel', {
          channelGroupId, channelId
        })
      }
      return {icon, title, api, ...i}
    })
}

export function getConnectedIntegrations(state, callbackURL) {
  const {integrations} = state.integrations
  const merchant = getCurrentMerchant(state)

  if (!merchant) return []

  let result

  if (!integrations || !integrations.length) {
    result = availableIntegrations
  } else {
    result = (getAllConnectedIntegrations(state) || [])
      .concat(availableIntegrations.filter(i => !integrations.find(t => t.serviceId === i.serviceId)))
  }

  return result
    .filter(i => i.api)
    .map(i => {
      const authURL = getAuthorizationURLParams(state, callbackURL)

      if (!authURL) return i

      return {
        ...i,
        authorizationURL: `${authURL.prefix}${i.serviceId}${authURL.postfix}`
      }
    })
}

export function getChannelIntegrations(state, channelGroup, channel) {
  const {integrations} = state.integrations

  if (!integrations) return null

  const channelIntegrations = availableIntegrations.filter(({channelId, channelGroupId, all}) => {
    return all || (channelId === channel && channelGroupId === channelGroup)
  })

  const found = channelIntegrations.reduce((acc, channelIntegration) => {
    const filteredIntegrations = integrations.filter(int => {
      if (int.serviceId !== channelIntegration.serviceId) return false
      const {channelId, channelGroupId} = channelIntegration
      const {channel: integrationChannel} = int.costConfig || {}
      const {channelGroupId: integrationGroupId, channelId: integrationChannelId} = integrationChannel || {}

      return (channelId === channel && channelGroupId === channelGroup) ||
        (integrationGroupId === channelGroup && integrationChannelId === channel)
    }).map(int => ({...channelIntegration, ...int}))

    return acc.concat(...filteredIntegrations)
  }, [])

  return [...found, ...channelIntegrations.sort(i => !i.api)]
}

export function getIntegration(state, integrationId) {
  const {isIntegrationsFetching, integrations} = state.integrations
  if (isIntegrationsFetching || !integrations) return null

  return integrations.find(item => item.id === integrationId)
}

export function getGroupedIntegrations(state) {
  const {integrations} = state.integrations

  if (!integrations) return null

  const normalizedIntegrations = getAllIntegrations(integrations)

  return _.chain(normalizedIntegrations)
    .groupBy('costConfig.channel.channelGroupId')
    .entries()
    .reduce((acc, [key, value]) => (
      {
        ...acc,
        [key]: {
          count: value.length,
          items: _.groupBy(value, 'costConfig.channel.channelId')
        }
      }
    ), {})
    .value()
}



// WEBPACK FOOTER //
// ./client/redux/modules/integrations/selectors.js